import { TestIdClassNameProps } from "@app/types/Common";
import { Field } from "@app/types/Cue";
import { Type } from "@app/types/enums";
import cx from "classnames";

export type SubHeadingProps = TestIdClassNameProps & { fields: Field[] };

export default function SubHeading({
  testId,
  rootClassName,
  fields,
}: SubHeadingProps): React.ReactElement {
  const text = fields.find((field) => field.name === Type.SubHead)?.value;
  const heading = fields.find((field) => field.name === Type.Headings)?.value;

  const HeadingTag = heading as "span" | "h2" | "h3" | "h4" | "h5" | "h6";

  return (
    <HeadingTag className={cx(rootClassName, "mb-6")} data-testid={testId}>
      {text}
    </HeadingTag>
  );
}
